var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 17.5C9.80686 17.5 9.60894 17.4646 9.40755 17.3939C9.20616 17.3232 9.02908 17.21 8.8763 17.0545L7.4388 15.7178C5.96658 14.3458 4.63672 12.9844 3.44922 11.6337C2.26172 10.2829 1.66797 8.7942 1.66797 7.16761C1.66797 5.83805 2.10547 4.72772 2.98047 3.83663C3.85547 2.94554 4.94575 2.5 6.2513 2.5C6.98741 2.5 7.68186 2.65912 8.33464 2.97737C8.98741 3.29562 9.54297 3.73055 10.0013 4.28218C10.4596 3.73055 11.0152 3.29562 11.668 2.97737C12.3207 2.65912 13.0152 2.5 13.7513 2.5C15.0569 2.5 16.1471 2.94554 17.0221 3.83663C17.8971 4.72772 18.3346 5.83805 18.3346 7.16761C18.3346 8.7942 17.7444 10.2864 16.5638 11.6443C15.3832 13.0021 14.043 14.367 12.543 15.739L11.1263 17.0545C10.9735 17.21 10.7964 17.3232 10.5951 17.3939C10.3937 17.4646 10.1957 17.5 10.0013 17.5Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite2);
export default __webpack_public_path__ + "static/media/favorite2.662186e6d7a513ecf2beb0d795035d80.svg";
export { ForwardRef as ReactComponent };